import './../../scss/blocks/_modal.scss'
import { bindRegistrationForms } from '../components/modalInit'

document.addEventListener('DOMContentLoaded', () => {
    if (document.documentElement.dataset.modalInlineBound === '1') {
        return
    }

    document.documentElement.dataset.modalInlineBound = '1'
    bindRegistrationForms(document)
})
